// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"216":"78c73364","497":"4e7c1602","533":"4d31a616","570":"5840784d","712":"5840784d"}[chunkId] + ".chunk.css";
};